import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {

    export class NordicFuryMB_1Screen extends SlotGameType1_1Screen {


        
        protected override helpFactory: IHelpFactory = new NordicFuryMBHelpFactory();
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "yellow",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }
        //LED COLOR
		protected override ColorLed:string="255,255,0\n";            
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "NordicFuryMB");

            this.spinnableReelsParams.topBorderWidth = 7;
            this.spinnableReelsParams.bottomBorderWidth = 7;
        }

    }

    //Help Colorized
    class NordicFuryMBHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new NordicFuryMBHelp(params);
        }
    }

    class NordicFuryMBHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }
